module.exports = __webpack_public_path__ + "img/team.23969b75.png";